import * as React from 'react';
import { VegobjekterStatistic } from '@/domain/vegobjekter/VegobjekterResult';
import { formatNumber } from '@/utils/Utils';

interface Props {
    statistics: VegobjekterStatistic[];
}

const displayLength = (length: number) => {
    if (!length) return null;
    return <span>{formatNumber(Math.round(length))} m</span>;
};

export const AreaSummary = ({ statistics }: Props) => {
    const totalCount = statistics.reduce((sum, r) => sum + r.antall, 0);
    const totalLength = statistics.reduce((sum, r) => sum + r.lengde, 0);
    const showLength = statistics.some(r => r.lengde > 0);
    const areaType = statistics[0]?.omrade?.getAreaType();

    return (
        <div className="c-area-summary">
            <table className="c-area-summary-table">
                <thead>
                    <tr>
                        <th>{areaType}</th>
                        <th className="c-area-count">Antall</th>
                        {showLength && <th className="c-area-length">Lengde</th>}
                    </tr>
                </thead>
                <tbody>
                    {statistics
                        .filter(r => r.antall > 0)
                        .map(r => {
                            if (!r.omrade) {
                                return null;
                            }

                            return (
                                <tr key={r.omrade.navn}>
                                    <td>{r.omrade.navn}</td>
                                    <td className="c-area-count">
                                        {formatNumber(r.antall)}
                                    </td>
                                    {showLength && (
                                        <td className="c-area-length">
                                            {displayLength(r.lengde)}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                </tbody>
                <tfoot className="c-area-sumary-table__footer">
                    <tr>
                        <td>Totalt</td>
                        <td className="c-area-count">{formatNumber(totalCount)}</td>
                        {showLength && (
                            <td className="c-area-length">
                                {displayLength(totalLength)}
                            </td>
                        )}
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};
